import axios from 'axios'

const state = {
    ubicacion:'',
    regiones:[],
    comunas:[],
    paises:[],
    paises_personal:[],
    paises_todos:[],
    ciudades:[],
    territorios:[],
    circunscripciones:[],
    localidades:[],
    formChileUrbano : {
        region: null,
        calle : null,
        comuna : null,
        villa_poblacion : null,
        numero : null,
        block_depto : null, 
        notificacion_correo : true, 
        latitud: null, 
        longitud: null
    },
    formChileRural: {
        region: null, 
        comuna: null, 
        localidad: null, 
        calle: null, 
        numero: null, 
        notificacion_correo : true, 
    },
    formExtranjero: {
        pais: null,
        division_territorial: null,
        ciudad: null,
        calle: null,
        numero: null,
        codigo_postal: null,
        block_depto: null,
        circunscripcion: null, 
        latitud: null, 
        longitud: null
    },
    formComun: {
        email : null,
        email2 : null,
        telefono : null  
    },
}

const mutations = { 
    SET_REGISTRO(state, payload) { state.registro = payload },   
    SET_UBICACION(state, payload) { state.ubicacion = payload },   
    

}

const actions = {

    async chanchePaisPersonal(state, val)
    {
        if(val)
           {

               state.state.paises_personal = state.state.paises_todos
               
           }

           if(!val)
           {

               state.state.paises_personal = state.state.paises_todos.filter(p => p.cod_pais != 'CL')
               
           }
    },
    async setRegistro(state, registro) 
    {   
        state.commit('SET_REGISTRO', registro)    
    
    },
    async changeUbicacion(state, payload)
    {
        state.commit('SET_UBICACION', payload)  

    },
    async cleanForm(state){
        // state.commit('SET_CLEAN')
    },
    async getLocalidad(state, val)
    {
        const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 
        state.state.localidades= []
        try {

            const payload = {}
            payload.territorio = 'localidades'  
            payload.cod_comuna = val
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error 
            
            state.state.localidades = datos.map(lo=>lo.localidad) 
            console.log(state.state.localidades )

        } catch (error) {
            console.error("Error al consultar por los localidades:: ", error)
            
        }

    },
    async getPaises(state)
    {
        const url = process.env.VUE_APP_API_URL_UTIL+'territorios'  
        state.state.paises = [] 
        state.state.paises_personal =[]
        state.state.paises_todos =[]
        try {

            const payload = {}
            payload.territorio = 'paises'  
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error  

            state.state.paises_todos = datos
            state.state.paises_personal = datos
            state.state.paises = datos.filter(p => p.cod_pais != 'CL')

        } catch (error) {
            console.error("Error al consultar por los paises:: ", error)
            
        }

    },
    async getTerritorios(state, val)
    {
         const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 


        state.state.territorios = []
        try {

            const payload = {}
            payload.territorio = 'regiones'
            payload.cod_pais = val
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error  

            state.state.territorios = datos

        } catch (error) {
            console.error("Error al consultar por los regiones:: ", error)
            
        }

    },
    async getCiudad(state, val)
    {
        const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 
        state.state.ciudades  = []
        try {

            const payload = {}
            payload.territorio = 'comunas'
            payload.cod_pais = state.state.formExtranjero.pais
            payload.cod_region = val
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error  

            state.state.ciudades = datos

        } catch (error) {
            console.error("Error al consultar por los regiones:: ", error)
            
        }

    },
    async getCircuncripciones(state, val)
    {
         const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 

        try {

            const payload = {} 
            payload.territorio = 'circunscripciones'
            payload.cod_pais = state.state.formExtranjero.pais
            payload.cod_comuna = val 
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error  

            state.state.circunscripciones = datos

        } catch (error) {
            console.error("Error al consultar por los regiones:: ", error)
            
        }

    },
    async getComunas(state, cod_region)
    {
        const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 
        state.state.comunas = []
        try {

            const payload = {}
            payload.territorio = 'comunas'
            payload.cod_pais = 'CL'
            payload.cod_region = cod_region
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error  

            state.state.comunas = datos

        } catch (error) {
            console.error("Error al consultar por los comunas:: ", error)
            
        }


    },
    async getRegiones(state, val)
    {
 

        const url = process.env.VUE_APP_API_URL_UTIL+'territorios' 
        state.state.regiones = []
        try {

            const payload = {}
            payload.territorio = 'regiones'
            payload.cod_pais = val
            
            const { data : { datos, error } } = await axios.post(url, payload)

            if(error) throw error   

            state.state.regiones = datos

        } catch (error) {
            console.error("Error al consultar por los regiones:: ", error)
            
        }
    }, 
}



export default {
    namespaced: true, 
    state,
    mutations,
    actions
}